export const SeatIcon = ({ className = "w-5 h-5" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M7 2.5h3.5a1 1 0 0 1 1 1V5" />
    <path d="M6.5 5h5.5l-1 8H5.5z" />
    <path d="M5.5 13h12a1.5 1.5 0 0 1 0 3h-12z" />
    <path d="M11 9.5h6" />
    <path d="M8 16l2 1.5-2 1.5 2 1.5M15 16l-2 1.5 2 1.5-2 1.5" />
    <path d="M6 21.5h11" />
  </svg>
);
